import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState("working"); // working | done | error
  const [email, setEmail] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.post("/marketing/unsubscribe", { token })
      .then((r) => { setEmail(r.data.email || ""); setState("done"); })
      .catch(() => setState("error"));
  }, [params]);

  return (
    <div className="min-h-screen bg-[#FBF9F5] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl border border-[#E6DEC3] p-8 text-center shadow-[0_4px_20px_rgba(44,38,33,0.04)]" data-testid="unsubscribe-card">
        <img src="/masaya-logo.png" alt="Masaya" className="h-12 w-auto mx-auto" />
        {state === "working" && <p className="mt-6 text-[#635B52]">Updating your preferences…</p>}
        {state === "done" && (
          <>
            <CheckCircle2 className="mx-auto mt-6 text-green-600" size={40} />
            <h1 className="mt-3 font-serif text-2xl text-[#2C2621]">You're unsubscribed</h1>
            <p className="mt-2 text-[#635B52]">{email && <strong>{email}</strong>} will no longer receive promotional emails. You'll still get booking confirmations, receipts, quotes, and appointment reminders.</p>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="mx-auto mt-6 text-red-500" size={40} />
            <h1 className="mt-3 font-serif text-2xl text-[#2C2621]">Link not valid</h1>
            <p className="mt-2 text-[#635B52]">This unsubscribe link is invalid or expired. Please email masayahospitality@gmail.com and we'll update your preferences.</p>
          </>
        )}
        <Link to="/" className="mt-6 inline-block bg-[#B87333] text-white rounded-full px-6 py-2.5 font-medium" data-testid="unsub-home">Back to home</Link>
      </div>
    </div>
  );
}
